// limit how often a function can fire
function debounce(func, wait = 100) {
  let timeout;
  return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function get_header_height() {
  return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
}

function disable_page_scroll() {
      
  // Get the current page scroll position
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

  // Prevent scrolling on the entire window
  window.onscroll = function() {
    window.scrollTo(scrollLeft, scrollTop);
  };

  // Add a class to the body for additional styling if needed
  document.body.classList.add('scroll-disabled');
}

function enable_page_scroll() {
  
  // Remove the scroll prevention
  window.onscroll = function() {};

  // Remove the class from the body
  document.body.classList.remove('scroll-disabled');
}

// Export all utilities
module.exports = {
  debounce,
  get_header_height,
  disable_page_scroll,
  enable_page_scroll
};